import { EnvironmentConfig } from './environment.model';

export const environment: EnvironmentConfig = {
  // Configure a reviewed project and exact storefront hosts before enabling.
  clarity: { enabled: false, allowedHosts: [] },
  production: true,
  apiUrl: 'https://fittara-devtest-cwcsa5hxb5g8d0gh.centralindia-01.azurewebsites.net',
  // LOCAL PREVIEW ONLY - DO NOT COMMIT.
  // The devtest host has no ShopDomains row, so the fallback resolved to no shop
  // at all and the storefront rendered 0 products on localhost.
  // 'the-fittara.com' is the only domain that resolves on devtest (-> shop 2).
  // Original value: 'fittara-devtest-cwcsa5hxb5g8d0gh.centralindia-01.azurewebsites.net'
  defaultShopDomain: 'the-fittara.com',
  sharedHostnames: [
    'fittara-devtest-cwcsa5hxb5g8d0gh.centralindia-01.azurewebsites.net',
    'purpleseamdevtest-d3bgh7ddhwewb3hu.centralindia-01.azurewebsites.net'
  ],
  sharedHostPrefixes: ['fittara-preview-', 'preview-'],
  sharedHostSuffixes: ['.preview.the-fittara.com', '.devtest.the-fittara.com'],
  adminHostPrefixes: ['admin'],
  compassHostPrefixes: ['fittaracompass'],
  computeServerHost: 'thefittara.net',
  runtimeEnvironmentLabel: 'DEV_TEST',
  usePreviewPaymentBridge: false,
  razorpayAccount: {
    secretKey: 'rzp_test_RbErZJqgpwn9zI'
  },
  razorpayRedirectUrl: 'https://fittara-devtest-cwcsa5hxb5g8d0gh.centralindia-01.azurewebsites.net',
  razorpayCheckoutDomain: 'https://fittara-devtest-cwcsa5hxb5g8d0gh.centralindia-01.azurewebsites.net',
  googleMapsApiKey: 'AIzaSyD-FRfRNUgEV8L39ppR-W1rvb-j3u4whJk',
  facebookPixelId: '1069592651566372',
  facebookOAuthRedirectUri: 'https://fittara-devtest-cwcsa5hxb5g8d0gh.centralindia-01.azurewebsites.net/auth/callback',
  disableClientPendingProcessing: true,
  analyticsWorkspaceV1: true,
  azureStorage: {
    baseUrl: 'https://fittarastoragev1.blob.core.windows.net',
    contentContainer: 'purpleseam-content'
  }
};
